module.exports = __webpack_public_path__ + "img/behavior.84ba05d8.png";